import Tagify from '@yaireo/tagify'

$(document).on('ready turbolinks:load', function() {
  const tagInput = document.getElementById('client-tags-selector');

  if (!tagInput) return;

  const clientId = tagInput.dataset.clientId;
  const userId = tagInput.dataset.userId;
  const clientTags = JSON.parse(tagInput.dataset.clientTags);
  const userTags = JSON.parse(tagInput.dataset.userTags);

  const tagify = new Tagify(tagInput, {
    whitelist: userTags,
    attachTagId: true,
    dropdown: {
      maxItems: 20,
      classname: "tags-look",
      enabled: 0,
      closeOnSelect: false
    }
  });
  tagify.addTags(clientTags);

  const createTag = async (event) => {
    const tag = event.detail.data;
    let tagId = tag.id;

    if (!tagId) {
      const { id } = await $.ajax({
        url: `/users/${userId}/tags`,
        data: {
          tag: {
            text: tag.value,
          },
        },
        type: 'post',
        dataType: 'json',
      });
      tagId = id;
      userTags.push({ id: id, value: tag.value });
    }

    const clientTag = await $.ajax({
      url: `/clients/${clientId}/client_tags`,
      data: {
        client_tag: {
          tag_id: tagId,
        },
      },
      type: 'post',
      dataType: 'json',
    });

    clientTags.push({ id: clientTag.id, value: tag.value });
  };

  const removeTag = (event) => {
    const removedTag = event.detail.data;
    const clientTag = clientTags.find(tag => tag.value === removedTag.value);

    if (!clientTag) return;

    $.ajax({
      url: `/clients/${clientId}/client_tags/${clientTag.id}`,
      type: 'delete',
      dataType: 'json',
    });
    clientTags.splice(clientTags.indexOf(clientTag), 1);
  }

  tagify.on('add', createTag);
  tagify.on('remove', removeTag);
});